// extracted by mini-css-extract-plugin
export default {"payment_modal":"CorporateHome_payment_modal__Vi-kE"};